import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { GamesComponent } from './games/games.component';

import { AddEditGameComponent } from './games/add-edit-game/add-edit-game.component';
import { UsersComponent } from './users/users.component';
import { TournamentsComponent } from './tournaments/tournaments.component';
import { CateComponent } from './cate/cate.component';
import { AddEditCateComponent } from './cate/add-edit-cate/add-edit-cate.component';
import { AddEditUserComponent } from './users/add-edit-user/add-edit-user.component';
import { AddEditTournamentComponent } from './tournaments/add-edit-tournament/add-edit-tournament.component';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { SubscriptionPlanAddEditComponent } from './subscription-plans/subscription-plan-add-edit/subscription-plan-add-edit.component';
import { HomeSettingComponent } from './home-setting/home-setting.component';
import { TournamentGamesComponent } from './tournament-games/tournament-games.component';
import { AddEditTgameComponent } from './tournament-games/add-edit-tgame/add-edit-tgame.component';
import { UploadGamesComponent } from './games/upload-games/upload-games.component';
import { AdminsComponent } from './admins/admins.component';
import { AddEditAdminComponent } from './admins/add-edit-admin/add-edit-admin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    GamesComponent,
    AddEditGameComponent,
    UsersComponent,
    TournamentsComponent,
    CateComponent,
    AddEditCateComponent,
    AddEditUserComponent,
    AddEditTournamentComponent,
    SubscriptionPlansComponent,
    SubscriptionPlanAddEditComponent,
    HomeSettingComponent,
    TournamentGamesComponent,
    AddEditTgameComponent,
    UploadGamesComponent,
    AdminsComponent,
    AddEditAdminComponent,
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    GamesComponent,
    AddEditGameComponent,
    UsersComponent,
    TournamentsComponent,
    CateComponent
  ]
})
export class ComponentsModule { }
